import * as URI from 'urijs';
import { WEBSITE_MODE } from '@sitegen/common/constants';
import { isEmbedded } from './css';

/** Window history should behave differently in certain application modes, like "Preview" */
export class WindowHistoryService {
    private static updateHistory: boolean = true;

    public static configure(options: { preview?: boolean, mode?: WEBSITE_MODE }): void {
        const disableHistoryUpdates: boolean = options.preview || isEmbedded(options.mode);
        WindowHistoryService.updateHistory = !disableHistoryUpdates;
    }

    public static pushState(basePath: string, path: string): void {
        if (!WindowHistoryService.updateHistory) {
            return; 
        }

        const url: string = new URI(window.location.origin)
            .segment([basePath, path])
            .search(window.location.search)
            .href();
        window.history.pushState({}, '', url);
    }
}
